import { render, staticRenderFns } from "./MarriageWsAck.vue?vue&type=template&id=64b66abe&"
import script from "./MarriageWsAck.vue?vue&type=script&lang=js&"
export * from "./MarriageWsAck.vue?vue&type=script&lang=js&"
import style0 from "./MarriageWsAck.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VForm,VLayout})
